import React from 'react';
import { ExternalLink as ExternalLinkIcon } from 'react-feather';
interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
}
export function ExternalLink({
  href,
  children
}: ExternalLinkProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-baseline text-[#111111] no-underline" data-id="element-127">
      {children}
      <sup className="inline-flex items-center ml-0.5" aria-hidden="true" data-id="element-128">
        <ExternalLinkIcon size={12} strokeWidth={1.5} data-id="element-129" />
      </sup>
    </a>;
}